import format from 'date-fns/format'

const nameDate = "@config@default@date"
const nameTime = "@config@default@time"


class DefaultDateTime {
  default_configs = {
    date: 'dd/MM/yyyy',
    time: 'HH:mm'
  }

  setDefault({ date, time }: {
    date: string,
    time: string
  }) {

    if (!date || !time) return

    localStorage.setItem(`${nameDate}`, date)
    localStorage.setItem(`${nameTime}`, time)

  }

  getDefault(iscomponent = false) {
    let date = localStorage.getItem(`${nameDate}`)!
    const time = localStorage.getItem(`${nameTime}`)!



    if (iscomponent) {
      date = date!.replaceAll("Y", "y")
    }

    return {
      time: time,
      date: date
    }
  }

  labelDateTime(value: Date | string) {
    try {
      const labels = format(new Date(value), `${this.getDefault().date} ${this.getDefault().time}`)
      return labels
    } catch {
      return value
    }
  }

  onlyTime(datetime: string) {
    const result = datetime.split(' ')

    // if (result.length === 3) {
    //   return `${result[1]} ${result[2]}`
    // }

    return `${result[1]}`
  }

  onlyDate(datetime: string) {
    const [date, _] = datetime.split(' ')

    return date
  }


  __init__config__app() {
    const date = localStorage.getItem(`${nameDate}`)
    const time = localStorage.getItem(`${nameTime}`)


    if (!date || !time) {
      this.setDefault(this.default_configs)
    }
  }

}


export const defaultDateTime = new DefaultDateTime()